var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000004703"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    d: "M33.9404 13.0946C34.9793 7.72246 29.265 3.52548 24.2434 6.04367C23.2044 2.5182 19.9144 0 15.9317 0C10.91 0 6.92735 4.36487 7.27367 9.23337C3.11783 9.56913 0.000976562 12.9267 0.000976562 16.9558C0.000976562 21.3207 3.46419 24.8462 7.96635 24.8462H33.9404C37.2304 24.8462 40.001 22.1601 40.001 18.9704C40.001 15.9486 37.5767 13.0946 33.9404 13.0946Z",
    fill: "url(#paint0_linear_312_3475)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1000002470"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_2",
    d: "M6.92946 28.0358C6.40998 27.7 5.54419 28.0358 5.37103 28.7073L3.29309 33.9116C2.94677 34.5831 3.29308 35.2546 3.98572 35.4225C4.5052 35.7582 5.37099 35.4225 5.54415 34.7509L7.62209 29.5467C7.96841 28.8752 7.62211 28.2036 6.92946 28.0358Z",
    fill: "url(#paint1_linear_312_3475)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_3",
    d: "M25.4579 27.1964C24.7652 26.8607 24.0726 27.1964 23.7263 27.8679L21.6484 33.0722C21.4752 33.7437 21.6484 34.4152 22.341 34.5831C23.0337 34.9189 23.7263 34.5831 23.8995 33.9116L26.1506 28.7073C26.3237 28.0358 25.9774 27.3643 25.4579 27.1964Z",
    fill: "url(#paint2_linear_312_3475)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_4",
    d: "M15.7595 32.4018C15.2401 32.2339 14.5474 32.5697 14.2011 33.0733L12.1232 38.2776C11.7768 38.9491 12.1232 39.6206 12.8158 39.9564C13.5084 40.1243 14.2011 39.7885 14.3742 39.2849L16.4522 33.9127C16.7985 33.4091 16.4522 32.7376 15.7595 32.4018Z",
    fill: "url(#paint3_linear_312_3475)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_5",
    d: "M32.3837 31.7308C31.691 31.5629 30.9984 31.8986 30.6521 32.5702L28.5742 37.7744C28.401 38.2781 28.5742 39.1175 29.2668 39.2853C29.9594 39.4532 30.6521 39.2853 30.8252 38.6138L33.0763 33.4096C33.2495 32.738 32.9031 32.0665 32.3837 31.7308Z",
    fill: "url(#paint4_linear_312_3475)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_312_3475",
    x1: 0.414829,
    y1: -23.1405,
    x2: 33.1958,
    y2: 6.16263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#437AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67A4FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_312_3475",
    x1: -31.1762,
    y1: -8.55361,
    x2: 17.2745,
    y2: 34.7572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#437AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67A4FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_312_3475",
    x1: -32.5474,
    y1: -26.0097,
    x2: 15.8946,
    y2: 17.2945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#437AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67A4FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_312_3475",
    x1: -36.6717,
    y1: -16.1708,
    x2: 11.7631,
    y2: 27.1269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#437AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67A4FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_312_3475",
    x1: -38.0337,
    y1: -31.7797,
    x2: 10.4048,
    y2: 11.521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#437AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67A4FE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRain);
export default __webpack_public_path__ + "static/media/rain.6f2bb7380532e7bbe40f5436af91f007.svg";
export { ForwardRef as ReactComponent };